import { styled, Typography } from "@mui/material";

const DisclaimerText = styled(Typography)({
  fontSize: "12px",
});

export const Disclaimer = () => (
  <DisclaimerText display="block" textAlign="center">
    MAITE is under development and may provide unexpected results. Always verify information before
    making important decisions.
  </DisclaimerText>
);
